//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Event } from "@alexrafael10/vue-tables-2";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignSearch",
  data() {
    return {
      query: ""
    };
  },
  watch: {
    query(val) {
      //eslint-disable-next-line vue/custom-event-name-casing
      Event.$emit("vue-tables.filter::name", val);
    }
  },
  activated() {
    this.query = "";
  }
});